"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useControlledQuantityPicker = useControlledQuantityPicker;
var _react = require("react");
var _constants = require("./constants");
/**
 * @param {UseQuantityPickerInnerProps} Props
 * @private
 */
function useControlledQuantityPicker(props) {
  const {
    groupValue,
    id,
    onChange,
    setLastIncreased,
    triggerClickEvent,
    setTooltipMaxOpen,
    value,
    maxValue = _constants.DEFAULT_MAX_VALUE,
    maxGroupValue = maxValue
  } = props;
  const max = Math.min(maxValue, maxGroupValue);
  const onIncrease = (0, _react.useCallback)(() => {
    triggerClickEvent(id);
    if (typeof value !== 'number') {
      return;
    }
    setLastIncreased(id);
    onChange?.(value + 1, id, 'increase');
  }, [id, onChange, setLastIncreased, triggerClickEvent, value]);
  const onDecrease = (0, _react.useCallback)(() => {
    triggerClickEvent(id);
    setLastIncreased('');
    if (typeof value !== 'number') {
      return;
    }
    onChange?.(value - 1, id, 'decrease');
  }, [id, onChange, setLastIncreased, triggerClickEvent, value]);
  const handleInputElement = (0, _react.useCallback)((action, inputValue) => {
    const source = action === 'change' ? 'input-change' : 'input-blur';
    if (inputValue === '' || inputValue === '-') {
      onChange?.(inputValue, id, source);
      return;
    }
    const num = Number.parseInt(inputValue, 10);
    if (!Number.isNaN(num)) {
      setTooltipMaxOpen(num > max);
      onChange?.(num, id, source);
    }
  }, [id, max, onChange, setTooltipMaxOpen]);
  const handleChange = (0, _react.useCallback)(({
    currentTarget
  }) => {
    triggerClickEvent(id);
    setLastIncreased('');
    handleInputElement('change', currentTarget.value);
  }, [handleInputElement, id, setLastIncreased, triggerClickEvent]);
  const handleBlur = (0, _react.useCallback)(({
    currentTarget
  }) => {
    triggerClickEvent(id);
    setLastIncreased(id);
    handleInputElement('blur', currentTarget.value);
  }, [handleInputElement, id, setLastIncreased, triggerClickEvent]);
  return {
    ...props,
    groupValue: groupValue ?? 0,
    handleBlur,
    handleChange,
    id,
    onDecrease,
    onIncrease,
    value: value
  };
}
//# sourceMappingURL=useControlledQuantityPicker.js.map